<script setup lang="ts">
import IconChevronRight from '@/assets/images/icons/fill/chevron-right.svg?component'
import { Position, Handle } from '@vue-flow/core'
</script>

<template>
  <div :class="$style.container">
    <IconChevronRight :class="$style.chevron" />
    <div :class="$style.body">開始</div>

    <Handle
      type="source"
      :connectable="false"
      :position="Position.Right"
      :class="$style.sourceHandle"
    />
  </div>
</template>

<style lang="scss" module>
.container {
  width: 88px;
  height: 88px;
  background-color: #ffffff;
  border: 2px solid transparent;
  border-radius: 999em;
  padding: 16px;
  box-sizing: border-box;
  box-shadow:
    0 1px 3px 0 rgb(0 0 0 / 10%),
    0 1px 2px -1px rgb(0 0 0 / 10%);
  cursor: initial;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 500;

  &:hover {
    box-shadow:
      0 10px 15px -3px rgb(0 0 0 / 10%),
      0 4px 6px -4px rgb(0 0 0 / 10%);
  }
}

.chevron {
  width: 36px;
  height: 36px;
  fill: $color-okaneko-blue;
}

.sourceHandle {
  opacity: 0;
  height: 0;
  min-height: 0;
  width: 0;
  min-width: 0;
}
</style>
